// ─── PHOENIX · Lot 1 — Drapeau de fonctionnalité (Strangler Pattern) ─────────
// La refonte UX du tunnel de publication est livrée DERRIÈRE un drapeau, à côté
// de l'ancien tunnel (pattern « strangler »). Tant que le drapeau est OFF, le
// comportement de production reste STRICTEMENT identique à aujourd'hui ; on peut
// donc merger en continu sans aucun risque pour les vrais utilisateurs.
//
// Bascule :  REACT_APP_PUBLISH_PHOENIX="1" (variable Railway, build front).
// Par défaut (absente / "0" / "false") → ancien tunnel.
//
// Pourquoi un helper plutôt que de lire process.env partout :
//   - une seule porte d'entrée (on saura toujours d'où vient la décision) ;
//   - testable (on peut mocker l'env) ;
//   - tolérant aux valeurs ("1", "true", "on", "yes" → vrai ; le reste → faux).

/** Coerce une valeur d'env (string|undefined) en booléen, tolérante. */
function envFlag(raw) {
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "1" || v === "true" || v === "on" || v === "yes";
}

/** Coerce une valeur d'env en booléen « explicitement faux ». */
function envFlagOff(raw) {
  if (raw == null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "0" || v === "false" || v === "off" || v === "no";
}

/**
 * Le nouveau tunnel PHOENIX est-il actif ?
 * RÉACTIVATION (16/08/2026, décision Lucas — refonte « aperçu final » façon
 * Leboncoin) : ON PAR DÉFAUT. /publish, l'espace association et l'édition
 * utilisent le tunnel PHOENIX (même moteur pour les trois).
 *   - variable absente / vide / autre → NOUVEAU tunnel (défaut) ;
 *   - REACT_APP_PUBLISH_PHOENIX="0"/"false"/"off"/"no" → COUPE-CIRCUIT :
 *     retour à l'ancien tunnel (NewPublishPage). ⚠️ REACT_APP_* est inliné au
 *     BUILD (CRA) : poser la variable Railway exige un REBUILD du service
 *     front (+ un bundle OTA pour les apps installées) — ce n'est PAS
 *     instantané (précision incident, revue Copilot #2186).
 * (Historique : rollback de juin 2026 → corrections QA faites, récap refondu.)
 * @returns {boolean}
 */
export function isPhoenixPublishEnabled() {
  return !envFlagOff(process.env.REACT_APP_PUBLISH_PHOENIX); // ON par défaut
}

// Export interne pour les tests (mock d'une valeur arbitraire).
export const __test__ = { envFlag };
